import React from "react";

export const CancellationEmail: React.FunctionComponent = (props) => {
  return <>Cancellation Email</>;
};
